"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentMethod = void 0;

var react_1 = __importStar(require("react"));

var react_nl2br_1 = __importDefault(require("react-nl2br"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

var Card_1 = require("../../components/Card");

var ComposedTypo_1 = require("../../components/ComposedTypo");

require("@suezenv/react-theme-components/assets/css/main.css");

var MultiCardRadio_1 = require("../../components/MultiCardRadio");

var LoadingModal_1 = require("../../components/LoadingModal");

var referenceFormatter_1 = __importDefault(require("../../utils/referenceFormatter"));

exports.PaymentMethod = function (_a) {
  var contractName = _a.contractName,
      reference = _a.reference,
      address = _a.address,
      messageError = _a.messageError,
      titlePage = _a.titlePage,
      cardsRadio = _a.cardsRadio,
      grayCard = _a.grayCard,
      info = _a.info,
      onChangeRadio = _a.onChangeRadio;

  var _b = __read(react_1.useState(true), 2),
      isDisabled = _b[0],
      setisDisabled = _b[1];

  var _c = __read(react_1.useState('#'), 2),
      toRedirect = _c[0],
      setToRedirect = _c[1];

  var _d = __read(react_1.useState('Poursuivre'), 2),
      valueBtn = _d[0],
      setValueBtn = _d[1];

  var _e = __read(react_1.useState(''), 2),
      labelPaymentChoice = _e[0],
      setLabelPaymentChoice = _e[1];

  var _f = __read(react_1.useState(false), 2),
      isLoadingBtn = _f[0],
      setIsLoadingBtn = _f[1];

  var disabledLoadingModal = !cardsRadio || (cardsRadio === null || cardsRadio === void 0 ? void 0 : cardsRadio.length) == 0;
  react_1.useEffect(function () {
    if (typeof cardsRadio == 'undefined' || !cardsRadio) {
      return;
    }

    var shownCards = cardsRadio.filter(function (card) {
      return card.showCard !== false;
    });

    if (shownCards.length === 0) {
      setLabelPaymentChoice('Aucun mode de paiement disponible');
    } else if (shownCards.length === 1) {
      setLabelPaymentChoice(shownCards[0].choice || '');
    } else {
      setLabelPaymentChoice('Sélectionnez un mode de règlement');
    }
  }, [cardsRadio]);

  var clickPaymentMethod = function clickPaymentMethod() {
    setIsLoadingBtn(true);
    window.location.href = toRedirect;
  };

  var onChange = function onChange(e, index, valueBtnSubmit, disabledBtnSubmit) {
    var target = e.target;
    setValueBtn(valueBtnSubmit);

    if (!disabledBtnSubmit) {
      setisDisabled(false);
    } else {
      setisDisabled(true);
    }

    setToRedirect(target.value);
    onChangeRadio(e, index, valueBtnSubmit);
  };

  return react_1.default.createElement("div", {
    className: "container p-0"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "h1",
    className: "ml-4 ml-md-5 pl-md-3 mb-3 py-2"
  }, titlePage), react_1.default.createElement("div", {
    className: "position-relative"
  }, react_1.default.createElement(LoadingModal_1.LoadingModal, {
    isDisabled: disabledLoadingModal
  }), react_1.default.createElement("div", {
    className: "bg-white pt-md-4 px-md-5 px-3"
  }, react_1.default.createElement("div", {
    className: "px-md-5"
  }, react_1.default.createElement("div", {
    className: "row mb-4 mb-md-4"
  }, react_1.default.createElement("div", {
    className: "row col-12 ml-2 mt-3 mb-2 mt-md-0 mb-md-0"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "h2",
    weight: "bold"
  }, "D\xE9tails du contrat")), react_1.default.createElement("div", {
    className: "col-12 col-lg-6 pl-lg-4 pr-md-4 mb-md-0 mb-3"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo, {
    className: "row ml-1 ml-md-0 pl-md-3 mb-3"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo.Icon, {
    icon: "business-contract-handshake-sign",
    variant: "line"
  }), react_1.default.createElement("div", {
    className: "col-11"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo.Title, null, 'Nom du contrat'), react_1.default.createElement(ComposedTypo_1.ComposedTypo.Text, null, contractName))), react_1.default.createElement(ComposedTypo_1.ComposedTypo, {
    className: "row ml-1 ml-md-0 pl-md-3 mb-3"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo.Icon, {
    icon: "single-neutral-id-card-3",
    variant: "line"
  }), react_1.default.createElement("div", {
    className: "col-11"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo.Title, null, 'Référence client'), react_1.default.createElement(ComposedTypo_1.ComposedTypo.Text, null, referenceFormatter_1.default(reference)))), react_1.default.createElement(ComposedTypo_1.ComposedTypo, {
    className: "row ml-1 ml-md-0 pl-md-3 mb-3"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo.Icon, {
    icon: "pin-location-1",
    variant: "line"
  }), react_1.default.createElement("div", {
    className: "col-11"
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo.Title, null, 'Adresse desservie'), react_1.default.createElement(ComposedTypo_1.ComposedTypo.Text, null, react_nl2br_1.default(address))))), react_1.default.createElement("div", {
    className: "col-12 col-lg-6 pl-lg-4 pr-md-0 pr-md-3 pr-lg-0"
  }, typeof grayCard !== 'undefined' && react_1.default.createElement(Card_1.Card, {
    title: grayCard.title,
    text: grayCard.content,
    type: grayCard.type,
    className: "d-flex align-items-center",
    align: "center",
    transparent: true,
    border: false
  }))), react_1.default.createElement("div", {
    className: "row"
  }, react_1.default.createElement("div", {
    className: "col-md-12 mb-3 ml-2"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "h2",
    weight: "bold"
  }, labelPaymentChoice))), react_1.default.createElement(MultiCardRadio_1.MultiCardRadio, {
    cardsRadio: cardsRadio,
    onChangeRadio: onChange,
    info: info
  })))), react_1.default.createElement("div", {
    className: "container px-md-5 pt-md-4 mt-4 mt-md-0"
  }, react_1.default.createElement("div", {
    className: "row px-md-5"
  }, messageError && react_1.default.createElement(react_theme_components_1.SzAlert, {
    variant: 'danger',
    className: 'col-12'
  }, messageError), react_1.default.createElement("div", {
    className: "col-12 pr-md-0 text-center text-md-left "
  }, react_1.default.createElement(react_theme_components_1.SzButton, {
    loader: isLoadingBtn,
    className: "float-md-right",
    onClick: clickPaymentMethod,
    isDisabled: isDisabled
  }, valueBtn)))));
};

exports.default = exports.PaymentMethod;